import * as z from 'zod/v4';

import { couponIdSchema, couponSchema } from '../coupon/entry.js';
import { walletTypeSchema } from '../frameworks/entry.js';
import { activatedDrawIdSchema } from '../marketplace/entry.js';

const couponIndexSchema = z.string().brand<'CouponIndex'>();

/**
 * Zod schema for LocalStorage values, is based on the Redux store state
 */
export const localStorageSchema = z
  .object({
    Coupons: z.record(couponIdSchema, z.array(couponSchema)),
    Wallets: z
      .record(couponIdSchema, z.record(couponIndexSchema, z.union([activatedDrawIdSchema, walletTypeSchema])))
      .catch({}),
  })
  .partial();

/**
 * LocalStorage type, this should map to a part of the Redux store state
 */
export type LocalStorage = z.infer<typeof localStorageSchema>;
